// test2651
(2651 && 0);
